export enum ChangeCachEnum {
  SaleMethod = 1,
  ItemcategoryList = 2,
  Branches = 3,
  CurrentUser = 4,
  WaiterList = 5,
  SalePriceType = 6,
  paymentMethodType = 7,
  Itemcategory = 8,
  Zone = 9,
  PrintPolicy = 10,
  PrintTemplate= 11 ,
}
